import { watchFetchItImpersonatePermissions } from './fetchItImpersonatePermissions';
import { watchFetchPermissions } from './fetchPermissions';
import { watchLogin } from './login';
import { watchLogout } from './logout';
import { watchrResetItOverides } from './resetItOverrides';
import { watchSetItOverrides } from './setItOverrides';

export const authSagas = [
  watchFetchPermissions(),
  watchLogin(),
  watchLogout(),
  watchFetchItImpersonatePermissions(),
  watchSetItOverrides(),
  watchrResetItOverides()
];
